import { render } from "./indexSubscribe.vue?vue&type=template&id=6fc9401c"
import script from "./indexSubscribe.vue?vue&type=script&lang=js"
export * from "./indexSubscribe.vue?vue&type=script&lang=js"

import "./indexSubscribe.vue?vue&type=style&index=0&id=6fc9401c&lang=css"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__